import { AddBuisnessPostComponent } from './../../../shared/components/add-buisness-post/add-buisness-post.component';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddAdminPostComponent } from 'src/app/shared/components/add-admin-post/add-admin-post.component';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { AddDiscountComponent } from '../add-discount/add-discount.component';
import { Router } from '@angular/router';
import { NavigationService } from '../../../providers/navigation.service';
import { SharedService } from 'src/app/providers/shared.service';


@Component({
  selector: 'sm-coupons',
  templateUrl: './coupons.component.html',
  styleUrls: ['./coupons.component.scss']
})
export class CouponsComponent implements OnInit, OnDestroy{
  clickEventSubscription: Subscription;
couponData:any=[];
public isLoading: boolean = false;
protected apiSubscription: Subscription = new Subscription();
 constructor(public _apiService: ApiService, private dialog: MatDialog, public router: Router,  public _navService: NavigationService, private sharedService: SharedService) {
  this._navService.hideSidebarAndNav = false;
  this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
    this.ngOnInit();
  })
  
 
 }


 ngOnInit(): void {
  this.isLoading = true;
  console.log("called");
  
  this._apiService.getDiscountCouponsList();
  // this._apiService.getBusinessList()
  


  this.apiSubscription = this._apiService.apiResult.subscribe((data) => {
    // this.isLoading = true;
    // console.log(data);
    // console.log(data.result);
    // console.log(data.result.length);
    if (data.responseType === SM_CONSTANTS.GET_COUPONS_LIST_RESULT) {
      console.log(data);
      // this.isLoading=false
       if(data.result && data.result!= null)
    {
      this.couponData=[];
      if(data.result.length > 1){
         data.result.forEach((element: any) => {
        this.couponData.push(element);
        // this.isLoading = false
      });
      }else {
          this.couponData = data.result
          // this.isLoading= false
      }
    }else{
      this.couponData = []
      // this.isLoading = false
    }
      
    }
    if (data.responseType === SM_CONSTANTS.GET_BUSINESS_LIST_RESULT) {
      console.log(data);
      // this.isLoading=false
    }
    
    // if(data.result && data.result!= null)
    // {
    //   this.couponData=[];
    //   if(data.result.length > 1){
    //      data.result.forEach((element: any) => {
    //     this.couponData.push(element);
    //     this.isLoading = false
    //   });
    //   }else {
    //       this.couponData = data.result
    //       this.isLoading= false
    //   }
    // }else{
    //   this.couponData = []
    //   this.isLoading = false
    // }
    this.isLoading = false
  })
 }

 changeStatus(item:any,value:any){
  console.log(item,value);
  let msg:string='';
  if(value == 1){
    msg = "Are you sure you want to enable the coupon?";
  }else if(value == 3){
    msg = "Are you sure you want to disable the coupon?";
  }

  if(confirm(msg)){
    let statusData = {
      couponHashId : item.hash_id,
      status : value
    }
    console.log(statusData);
    this._apiService.createAndUpdateCoupon(statusData);
    // this.apiSubscription.unsubscribe();
    setTimeout(() => {
      this.ngOnInit()
    }, 1000);
  
    // this.reloadCurrentRoute();
    // this.router.navigate(['/promotion', 'coupons'], {queryParams:{'changed' : 'yes'}})


  }
  window.location.reload()
}
reloadCurrentRoute() {
  const currentUrl = this.router.url;
  this.router.navigateByUrl('coupons', {skipLocationChange: true}).then(() => {
      this.router.navigate([currentUrl]);
  });
}
deleteCoupon(item:any,value:any){
  console.log("fire");
  console.log(item,value);
  let msg:string='';
  if(value == 2){
    msg = "Are you sure you want to delete the coupon?";
  }

  if(confirm(msg)){
    let statusData = {
      couponHashId : item.hash_id,
      status : value
    }
    console.log(statusData);
    this._apiService.createAndUpdateCoupon(statusData);
    // this.apiSubscription.unsubscribe();
    setTimeout(() => {
      this.ngOnInit()
    }, 1000);
  
    // this.reloadCurrentRoute();
    // this.router.navigate(['/promotion', 'coupons'], {queryParams:{'changed' : 'yes'}})


  }
  
  // if(confirm("Are you sure you want to delete the coupon?")){
  //   let statusData= {
  //     hash_id : item.hash_id,
  //     status : 2
  //   }
    // this.apiService.updateCouponStatus(statusData);
  // }
}

// AddCoupon() {
  
//   console.log("fire");
//   let dialogRef = this.dialog.open(AddDiscountComponent, {
   
//     disableClose: true,
//   });
// }
AddCoupon() {
  console.log("fire");
  let dialogRef = this.dialog.open(AddDiscountComponent, {
    disableClose: true,
    width: '500px' // Set the dialog width to 500px
  });
}


 ngOnDestroy(){
  this.apiSubscription.unsubscribe();
 }
}


